import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [

  // GENERAL ===

  {
    path: "/nuzul",
    name: "nuzul",
    component: () => import("../views/TemplateVue.vue"),
    meta: { showLeftPanel: false, showMainHeader: false, showMobileHeaderAdmin: false },
  },

  {
    path: "/",
    name: "Loading...",
    component: () => import("../views/Loading.vue"),
    meta: { showLeftPanel: false, showMainHeader: false, showMobileHeaderAdmin: false },
  },

  {
    path: "/loading",
    name: "Loading..",
    component: () => import("../views/Loading.vue"),
    meta: { showLeftPanel: false, showMainHeader: false, showMobileHeaderAdmin: false },
  },

  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/Logout.vue"),
    meta: { showLeftPanel: false, showMainHeader: false, showMobileHeaderAdmin: false },
  },


  // LOGIN ===

  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Admin/Login.vue"),
    meta: { showLeftPanel: false, showMainHeader: false },
  },


  // FORGOT PASSWORD ===

  {
    path: "/ForgotPassword",
    name: "Forgot Password",
    component: () => import("../views/ForgotPassword.vue"),
    meta: { showLeftPanel: false, showMainHeader: false, showMobileHeaderAdmin: false },
  },
  

  // REGISTER USER ===

  {
    path: "/pendaftaran",
    name: "Pendaftaran",
    component: () => import("../views/Admin/Register.vue"),
    meta: { showLeftPanel: false, showMainHeader: false, showMobileHeaderAdmin: false },
  },


  // ADMIN ===

  {
    path: "/Dashboard",
    name: "Dashboard",
    component: () => import("../views/Admin/Admin/Dashboard.vue"),
    meta: { showLeftPanel: true, showMainHeader: false, showMobileHeaderAdmin: true },
  },

  {
    path: "/PengurusanPengguna",
    name: "Pengurusan Pengguna",
    component: () => import("../views/Admin/Admin/PengurusanPengguna.vue"),
    meta: { showLeftPanel: true, showMainHeader: false, showMobileHeaderAdmin: true },
  },

  {
    path: "/PengurusanTetapanPentadbir",
    name: "Pengurusan Tetapan Pentadbir",
    component: () => import("../views/Admin/Admin/PengurusanTetapanPentadbir.vue"),
    meta: { showLeftPanel: true, showMainHeader: false, showMobileHeaderAdmin: true },
  },

  {
    path: "/PengurusanAduan",
    name: "Pengurusan Aduan",
    component: () => import("../views/Admin/Admin/PengurusanAduan.vue"),
    meta: { showLeftPanel: true, showMainHeader: false, showMobileHeaderAdmin: true },
  },

  {
    path: "/PengurusanEmel",
    name: "Pengurusan E-mel",
    component: () => import("../views/Admin/Admin/PengurusanEmel.vue"),
    meta: { showLeftPanel: true, showMainHeader: false, showMobileHeaderAdmin: true },
  },

  {
    path: "/PengurusanPermohonanData",
    name: "Pengurusan Permohonan Data",
    component: () => import("../views/Admin/Admin/PengurusanPermohonanData.vue"),
    meta: { showLeftPanel: true, showMainHeader: false, showMobileHeaderAdmin: true },
  },

  {
    path: "/PengurusanAnalisisMakmal",
    name: "Pengurusan Analisis Makmal",
    component: () => import("../views/Admin/Admin/PengurusanAnalisisMakmal.vue"),
    meta: { showLeftPanel: true, showMainHeader: false, showMobileHeaderAdmin: true },
  },

  {
    path: "/PengurusanPemantauan",
    name: "Pengurusan Pemantauan",
    component: () => import("../views/Admin/Admin/PengurusanPemantauan.vue"),
    meta: { showLeftPanel: true, showMainHeader: false, showMobileHeaderAdmin: true },
  },

  {
    path: "/AuditTrail",
    name: "Audit Trail",
    component: () => import("../views/Admin/Admin/AuditTrail.vue"),
    meta: { showLeftPanel: true, showMainHeader: false, showMobileHeaderAdmin: true },
  },

  {
    path: "/Laporan",
    name: "Laporan",
    component: () => import("../views/Admin/Admin/Laporan.vue"),
    meta: { showLeftPanel: true, showMainHeader: false, showMobileHeaderAdmin: true },
  },

  {
    path: "/ManualPengguna",
    name: "Manual Pengguna",
    component: () => import("../views/Admin/UserManualAdmin.vue"),
    meta: { showLeftPanel: true, showMainHeader: false, showMobileHeaderAdmin: true },
  },


  // ADUAN BENCANA

  {
    path: "/aduanbencana",
    name: "Aduan Bencana",
    component: () => import("../views/AduanBencana/AduanBencana.vue"),
    meta: { showLeftPanel: false, showMainHeader: true, showMobileHeaderAdmin: false },
  },


  // ANALISIS MAKMAL

  {
    path: "/analisismakmal",
    name: "Analisis Makmal",
    component: () => import("../views/AnalisisMakmal/AnalisisMakmal.vue"),
    meta: { showLeftPanel: false, showMainHeader: true, showMobileHeaderAdmin: false },
  },


  // KAJIAN KEPUASAN PELAWAT

  {
    path: "/KajianKepuasanPelawat",
    name: "Kajian Kepuasan Pelawat",
    component: () => import("../views/KajianKepuasanPelawat/KajianKepuasanPelawat.vue"),
    meta: { showLeftPanel: false, showMainHeader: true, showMobileHeaderAdmin: false },
  },

  // PERMOHONAN DATA TERBUKA

  // {
  //   path: "/PermohonanDataTerbuka",
  //   name: "Permohonan Data Terbuka",
  //   component: () => import("../views/PermohonanTerbuka/PermohonanDataTerbuka.vue"),
  //   meta: { showLeftPanel: false, showMainHeader: true, showMobileHeaderAdmin: false },
  // },

  // PERMOHONAN DATA TERHAD

  {
    path: "/PermohonanDataTerhad",
    name: "Permohonan Data Terhad",
    component: () => import("../views/PermohonanTerhad/PermohonanDataTerhad.vue"),
    meta: { showLeftPanel: false, showMainHeader: true, showMobileHeaderAdmin: false },
  },

  // SEMAKAN PERMOHONAN DATA TERHAD

  {
    path: "/SemakanPermohonanDataTerhad",
    name: "Semakan Permohonan Data Terhad",
    component: () => import("../views/SemakStatus/SemakStatus.vue"),
    meta: { showLeftPanel: false, showMainHeader: true, showMobileHeaderAdmin: false },
  },

  // DASHBOARD ANALISIS MAKMAL PORTAL

  {
    path: "/DashboardAnalisisMakmalPortal",
    name: "Dashboard Analisis Makmal Portal",
    component: () => import("../views/Admin/Admin/DashboardAnalisisMakmalPortal.vue"),
    meta: { showLeftPanel: false, showMainHeader: true, showMobileHeaderAdmin: false },
  },


];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
